import { CalendarV2EarningEvent } from "@/shared/models/economic-calendar-v2/CalendarV2Event";
import { formatNumber, getArrowAndColor } from "./common";
import { ClassificationBadge, DetailStat } from "./presentational";

/**
 * Trailing cells for an `earning` row: EVENT + a detail cell spanning the seven
 * figure columns (the earnings figures don't map onto the data ACT/EXP/… grid).
 */
export function EarningRowCells({ event }: { event: CalendarV2EarningEvent }) {
  const { color, arrow } = getArrowAndColor(
    event.eps_actual,
    event.eps_forecast ?? event.eps_previous
  );

  return (
    <>
      <td className="px-1 whitespace-normal leading-normal min-w-[150px]">
        <p>
          <ClassificationBadge label="Earnings" />
          {event.ticker && (
            <span className="font-semibold">{event.ticker} </span>
          )}
          {event.summary}
        </p>
      </td>
      <td colSpan={7} className="px-1 whitespace-nowrap">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-0.5">
          <DetailStat
            label="EPS"
            value={
              event.eps_actual != null ? (
                <span className={color}>
                  {formatNumber(event.eps_actual, { currency: event.currency })}{" "}
                  {arrow}
                </span>
              ) : (
                "—"
              )
            }
          />
          <DetailStat
            label="Fcst"
            value={formatNumber(event.eps_forecast, { currency: event.currency })}
          />
          <DetailStat
            label="Prev"
            value={formatNumber(event.eps_previous, { currency: event.currency })}
          />
          <DetailStat
            label="Rev"
            value={formatNumber(event.revenue_actual, {
              currency: event.currency,
              compact: true,
            })}
          />
          <DetailStat
            label="Rev Fcst"
            value={formatNumber(event.revenue_forecast, {
              currency: event.currency,
              compact: true,
            })}
          />
          <DetailStat
            label="Mkt Cap"
            value={formatNumber(event.market_cap, { compact: true })}
          />
        </div>
      </td>
    </>
  );
}
